import React, { useEffect, useState } from "react";

export default function InstallPrompt() {
  const [installEvent, setInstallEvent] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      // Prevent Chrome from showing its own automatic prompt
      event.preventDefault();

      // Save the installation event for our button
      setInstallEvent(event);

      // Show our prompt after the dashboard has loaded
      setTimeout(() => {
        setShowPrompt(true);
      }, 1500);
    };

    window.addEventListener(
      "beforeinstallprompt",
      handleBeforeInstallPrompt
    );

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleInstall = async () => {
    if (!installEvent) return;

    await installEvent.prompt();

    const result = await installEvent.userChoice;

    if (result.outcome === "accepted") {
      console.log("EasyGreeks app installed");
    }

    setInstallEvent(null);
    setShowPrompt(false);
  };

  const handleSkip = () => {
    setShowPrompt(false);
  };

  if (!showPrompt) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0, 0, 0, 0.45)",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "360px",
          background: "#ffffff",
          borderRadius: "18px",
          padding: "28px 22px",
          textAlign: "center",
          boxShadow: "0 20px 50px rgba(0,0,0,0.25)",
        }}
      >
        <img
          src="/logo192.png"
          alt="EasyGreeks"
          style={{
            width: "72px",
            height: "72px",
            objectFit: "contain",
            marginBottom: "14px",
          }}
        />

        <h2
          style={{
            margin: "0 0 8px",
            fontSize: "22px",
            fontWeight: 700,
            color: "#0F172A",
          }}
        >
          Install EasyGreeks
        </h2>

        <p
          style={{
            margin: "0 0 22px",
            fontSize: "14px",
            lineHeight: 1.5,
            color: "#64748B",
          }}
        >
          Get faster access to your Analytics dashboard.
        </p>

        <button
          onClick={handleInstall}
          style={{
            width: "100%",
            border: "none",
            borderRadius: "10px",
            padding: "12px",
            background: "#4F46E5",
            color: "#ffffff",
            fontSize: "15px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Install App
        </button>

        <button
          onClick={handleSkip}
          style={{
            marginTop: "12px",
            border: "none",
            background: "transparent",
            color: "#64748B",
            fontSize: "14px",
            cursor: "pointer",
          }}
        >
          Skip & Continue
        </button>
      </div>
    </div>
  );
}